<script lang="ts">
	import InputCheckbox from '$lib/elements/inputs/variants/InputCheckbox.svelte';
	import InputFileKyc from '$lib/elements/inputs/variants/InputFileKYC.svelte';
	import type { KYCQuestionProps } from '@app/models/api/KYCModel';
	import { TypeAttestDom } from '@app/models/api/enums/TypeAttestDom';
	import { findPropsByApiKey } from '@app/utils/kyc';
	import { beforeUpdate } from 'svelte';
	import { t } from 'svelte-i18n';
	export let props: any;

	let typeDom: KYCQuestionProps | undefined;
	let attestationTiers: KYCQuestionProps | undefined;
	let cniTiers: KYCQuestionProps | undefined;
	let thirdLegalPersonProps = {
		label: $t('kyc.inputs.thirdLegalPerson'),
		classNames: 'text-left my-4',
		showPreview: false
	};

	$: typeDom = props?.questions ? findPropsByApiKey(props?.questions, 'typeAttestDom') : {};
	$: attestationTiers = props?.questions
		? findPropsByApiKey(props?.questions, 'attestationTiers')
		: {};
	$: cniTiers = props?.questions ? findPropsByApiKey(props?.questions, 'cniTiers') : {};

	$: if (props) {
		props.showPreview = true;
	}
	beforeUpdate(() => {
		if (typeDom) {
			typeDom.value = thirdLegalPersonProps.checked ? TypeAttestDom.TIERS : TypeAttestDom.PERSO;
			attestationTiers.required = thirdLegalPersonProps.checked;
			cniTiers.required = thirdLegalPersonProps.checked;
		}
	});
</script>

{#if props}
	{#if props.readonly && props.state !== 'INVALID'}
		<InputFileKyc bind:props />
	{:else}
		<div>
			<div class="my-3">
				<InputFileKyc bind:props />
				<InputCheckbox bind:props={thirdLegalPersonProps} />
			</div>

			{#if thirdLegalPersonProps.checked}
				<div class="mb-3"><InputFileKyc bind:props={attestationTiers} /></div>

				<div class="mb-3"><InputFileKyc bind:props={cniTiers} /></div>
			{/if}
		</div>
	{/if}
{/if}
